import {html, css, LitElement, svg, ref, createRef} from 'lit';


export class LayoutSwitcher extends LitElement {
  
  icons = {
    list: svg`
      <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M7.11393 14.75H18.5121C18.5923 14.75 18.6658 14.7166 18.7324 14.6497C18.7993 14.5831 18.8327 14.5096 18.8327 14.4294V11.7031H7.11393V14.75ZM2.16602 5.29688H5.55143V2.25H2.48659C2.40638 2.25 2.33294 2.28342 2.26628 2.35026C2.19944 2.41693 2.16602 2.49036 2.16602 2.57057V5.29688ZM2.16602 10.1667H5.55143V6.85937H2.16602V10.1667ZM2.48659 14.75H5.55143V11.7031H2.16602V14.4294C2.16602 14.5096 2.19944 14.5831 2.26628 14.6497C2.33294 14.7166 2.40638 14.75 2.48659 14.75ZM7.11393 10.1667H18.8327V6.85937H7.11393V10.1667ZM7.11393 5.29688H18.8327V2.57057C18.8327 2.49036 18.7993 2.41693 18.7324 2.35026C18.6658 2.28342 18.5923 2.25 18.5121 2.25H7.11393V5.29688ZM2.48659 16.3125C1.96037 16.3125 1.51497 16.1302 1.15039 15.7656C0.785807 15.401 0.603516 14.9556 0.603516 14.4294V2.57057C0.603516 2.04436 0.785807 1.59896 1.15039 1.23438C1.51497 0.869792 1.96037 0.6875 2.48659 0.6875H18.5121C19.0383 0.6875 19.4837 0.869792 19.8483 1.23438C20.2129 1.59896 20.3952 2.04436 20.3952 2.57057V14.4294C20.3952 14.9556 20.2129 15.401 19.8483 15.7656C19.4837 16.1302 19.0383 16.3125 18.5121 16.3125H2.48659Z"/>
      </svg>
    `,
    card: svg`
      <svg width="21" height="17" viewBox="0 0 21 17" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M18.9587 14.1697V9.40617H2.04199V14.1697C2.04199 14.2628 2.08076 14.3479 2.15829 14.4253C2.23563 14.5028 2.32081 14.5416 2.41386 14.5416H18.5868C18.6798 14.5416 18.765 14.5028 18.8424 14.4253C18.9199 14.3479 18.9587 14.2628 18.9587 14.1697ZM18.9587 7.59367V2.83012C18.9587 2.73707 18.9199 2.65189 18.8424 2.57455C18.765 2.49702 18.6798 2.45825 18.5868 2.45825H2.41386C2.32081 2.45825 2.23563 2.49702 2.15829 2.57455C2.08076 2.65189 2.04199 2.73707 2.04199 2.83012V7.59367H18.9587ZM2.41386 16.3541C1.80345 16.3541 1.28678 16.1426 0.863867 15.7197C0.440951 15.2968 0.229492 14.7801 0.229492 14.1697V2.83012C0.229492 2.21971 0.440951 1.70304 0.863867 1.28013C1.28678 0.85721 1.80345 0.645752 2.41386 0.645752H18.5868C19.1972 0.645752 19.7139 0.85721 20.1368 1.28013C20.5597 1.70304 20.7712 2.21971 20.7712 2.83012V14.1697C20.7712 14.7801 20.5597 15.2968 20.1368 15.7197C19.7139 16.1426 19.1972 16.3541 18.5868 16.3541H2.41386Z"/>
      </svg>
    `
  }

  static get properties() {
    return {
      "table": {type: String},
      "switcher": {type: String}
    }
  }

  connectedCallback() {
    super.connectedCallback()
    this.modes = ["card-view", "list-view"]
    this.modeIndex = BX.getCookie("ui.catalog.view.modeIndex") || 0

    if (this.modeIndex == 1) {
      this.toggle()
    }

    this.addEventListener("click", this.toggle)
  }


  toggle() {
    this.classList.toggle("active")
    this.modeIndex = (this.modeIndex + 1) % this.modes.length

    let t = document.querySelector(this.table)
    for (let mode of this.modes) {
      t.classList.remove(mode)
    }
    t.classList.add(this.modes[this.modeIndex])
    BX.setCookie("ui.catalog.view.modeIndex", this.modeIndex, {expires: 86400, path: "/catalog"})

    for (let switcher of t.querySelectorAll(this.switcher)) {
      switcher.selector = this.modes[this.modeIndex]
    }
  }

  render() {
    return html`
      <div class="backdrop"></div>
      <button class="card-switch">${this.icons.card}</button>
      <button class="list-switch">${this.icons.list}</button>
    `
  }

  static get styles() {
    return css`
       :host {
          display: block;
          position: relative;
          height: 30px;
          border-radius: 30px;
          background: rgba(0, 0, 0, 0.05);
          box-shadow: inset 2px 4px 3px rgba(0, 0, 0, 0.06);
          width: 80px;
          z-index: 1;
          transition: 0.2s;
       }

       .backdrop {
          position: absolute;
          top: 0px;
          left: 1px;
          z-index: 1;
          width: 38px;
          height: 30px;
          border-radius: 30px;
          background: linear-gradient(129.61deg, #F95700 16.3%, #FD9200 84.86%);
          transform: translate(0px, 0px);
          transition: 0.2s;
       }

       :host(.active) .backdrop {
        left: calc(100% - 39px);
       }
       
       .card-switch,
       .list-switch {
          position: absolute;
          top: 0px;
          appearance: none;
          width: 30px;
          height: 30px;
          display: flex;
          justify-content: center;
          align-items: center;
          padding: 0px;
          border: none;
          border-radius: 50%;
          background: none;
          z-index: 2;
       }

       .card-switch {
          left: 5px;
       }

       .card-switch path {
          fill: white;
          transition: 0.2s;
       }

       :host(.active) .card-switch path {
          fill: black;
       }

       .list-switch {
          right: 5px;
       }

       .list-switch path {
          fill: black;
          transition: 0.2s;
       }

       :host(.active) .list-switch path {
          fill: white;
       }
    `
  }
}

customElements.define('layout-switcher', LayoutSwitcher);



const filterIcon = svg`
<svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
  <path d="M8 18V12H10V14H18V16H10V18H8ZM0 16V14H6V16H0ZM4 12V10H0V8H4V6H6V12H4ZM8 10V8H18V10H8ZM12 6V0H14V2H18V4H14V6H12ZM0 4V2H10V4H0Z" fill="#1C1B1F"/>
</svg>
`


export class SortTypeChooser extends LitElement {
  $dropdown = createRef()
  $backdrop = createRef()

  static get properties() {
    return {
      "sidebar": {type: String},
      "showFilters" : {type: String}
    }
  }


  icons = {
    price_asc: svg`
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 0V2H11V0H7ZM3 5V7H15V5H3ZM0 10V12H18V10H0Z" fill="#1C1B1F"/>
        </svg>
    `,
    price_desc: svg`
        <svg width="18" height="12" viewBox="0 0 18 12" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M7 12V10H11V12H7ZM3 7V5H15V7H3ZM0 2V0H18V2H0Z" fill="#1C1B1F"/>
        </svg>
    `,
    unknown: svg`
        <svg width="16" height="13" viewBox="0 0 16 13" fill="none" xmlns="http://www.w3.org/2000/svg">
          <path d="M0.788997 3.56809L4.66712 0.596435L8.54525 3.56809L7.66712 4.25086L5.29212 2.43099L5.29212 12.0903L4.04212 12.0903L4.04212 2.43099L1.66712 4.25086L0.788997 3.56809ZM7.45566 9.75723L8.33379 9.07446L10.7088 10.8943L10.7088 1.23499L11.9588 1.23499L11.9588 10.8943L14.3338 9.07446L15.2119 9.75723L11.3338 12.7289L7.45566 9.75723Z" fill="#1C1B1F"/>
        </svg>
    `
  }

  connectedCallback() {
    super.connectedCallback()
    this.mode = BX.getCookie("ui.catalog.sort.mode") || "unknown"
  }

  render() {
    return html`
      ${JSON.parse(this.showFilters) ? html`<div class="panel" @click=${this.toggleFilter}>${filterIcon}</div>` : ``}
      <div class="panel" @click=${this.toggle}>
        <div class="title">Упорядочить</div>
        ${this.icons[this.mode]}
      </div>
      <div class="backdrop" ${ref(this.$backdrop)} @click=${this.toggle}></div>
      <div class="dropdown">
        <div class="option" @click=${() => this.choose("price_asc")}>Сначала дешевле</div>
        <div class="option" @click=${() => this.choose("price_desc")}>Сначала дороже</div>  
      </div>
    `
  }

  toggle() {
    this.$backdrop.value.classList.toggle("visible")
    this.requestUpdate()
  }

  toggleFilter() {
    let fp = document.querySelector(this.sidebar)
    fp.classList.toggle("active")
  }


  makePostRequest() {
    let form = document.createElement("form")
    form.style.display = "none"
    form.action = window.location.href
    form.method = "POST"
    form.target = "_top"

    let input = document.createElement("input")
    input.type = "hidden"
    input.name = "sort_items"
    input.value = this.mode
    form.appendChild(input)

    document.body.appendChild(form)
    BX.setCookie("ui.catalog.sort.mode", this.mode, {expires: 86400, path: "/catalog"})
    form.submit()
  }

  choose(mode) {
    this.mode = mode
    this.makePostRequest()
    this.toggle()
  }


  static get styles() {
    return css`
      :host {
        position: relative;
        display: flex;
        align-items: center;
        gap: 10px;
        font-family: 'Roboto Medium';
        z-index: 20;
      }

      .backdrop {
        display: none;
        position: fixed;
        width: 100vw;
        height: 100vh;
        top: 0px;
        left: 0px;
        z-index: 21;
      }

      .backdrop.visible {
        display: block;
      }

      .panel {
        display: inline-flex;
        align-items: center;
        gap: 10px;
        background: rgba(0, 0, 0, 0.05);
        padding: 5px 15px;
        border-radius: 20px;
        cursor: pointer;
      }

      .dropdown {
        display: none;
        position: absolute;
        background: white;
        border: 1px solid #E0E0E0;
        box-shadow: 0px 4px 5.2px rgba(0, 0, 0, 0.19);
        border-radius: 14px;
        width: 100%;
        min-width: 150px;
        left: 0px;
        gap: 8px;
        top: calc(100% + 5px);
        padding: 15px;
        z-index: 22;
      }

      .dropdown .option {
        cursor: pointer;
      }

      .backdrop.visible ~ .dropdown {
        display: flex;
        flex-direction: column;
      }
    `
  }
}

customElements.define('sort-type-chooser', SortTypeChooser);